module.exports = __webpack_public_path__ + "img/questionBankBtn.87d7d107.png";